// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Xu7u","field":"styles_field__qeMAu","fieldCol":"styles_fieldCol__37Uhc","diffCol":"styles_diffCol__2xJUU","diff":"styles_diff__mVTEj"};